import React, { useState } from "react";
import { Button, Divider, Form, Checkbox, Typography } from "antd";
import { API_BASE_URL } from "../../utils/constants";
import { CheckOutlined } from "@ant-design/icons";

import axios from "axios";
import moment from "moment";
import { NavLink, useHistory } from "react-router-dom";
import bg_onboarding from "../../images/icons/bg_onboarding.png";

function Step4(props) {
  let history = useHistory();
  const { moveBackStep, formData } = props;
  const [createItem, setCreateItem] = useState("non_inventory");
  const [isShowLoading, setIsShowLoading] = useState(false);
  const optionsCreateItems = [
    { label: "Non-Inventoried Items", value: "non_inventory" },
    { label: "Inventoried Items", value: "inventory_part" },
  ];
  const tickIconColor = "#2CA01C";
  const [form] = Form.useForm();

  function onChangeCreateItem(e) {
    setCreateItem(e.target.value);
  }

  const SaveSettings = async (e) => {
    setIsShowLoading(true);
    await axios
      .all([
        axios.post(API_BASE_URL + "/api/qbo/saveAccountSettings", formData),
        axios.post(API_BASE_URL + "/api/company/updateStatus", {
          companyId: formData.comp_id,
          status: "complete",
        }),
      ])
      .then(
        axios.spread((data1, data2) => {
          // output of req.

          if (data1.status === 200 && data2.status === 200) {
            setIsShowLoading(false);
            history.push("/" + formData.comp_id);
          } else {
            console.log("check apis, may have error");
          }
        })
      );
  };

  async function onFinish(values) {
    console.log("Values :", values);
    if (values.termsAndConditions === false) {
      form.setFields([
        {
          name: 'termsAndConditions',
          errors: ['Please check terms and conditions!'],
        },
     ]);
    }else{

      // console.log("ready to save settings");
      setIsShowLoading(true);
      formData.termsAndConditions = values.termsAndConditions+"";
      await axios
        .all([
          axios.post(API_BASE_URL + "/api/qbo/saveAccountSettings", formData),
          axios.post(API_BASE_URL + "/api/company/updateStatus", {
            companyId: formData.comp_id,
            status: "complete",
          }),
        ])
        .then(
          axios.spread((data1, data2) => {
            // output of req.
  
            if (data1.status === 200 && data2.status === 200) {
              setIsShowLoading(false);
              history.push("/" + formData.comp_id);
            } else {
              console.log("check apis, may have error");
            }
          })
        );
    }

    



  }

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div
      className="
  h-screen w-full  bg-cover bg-center lg:bg-cover lg:bg-no-repeat bg-no-repeat
  grid grid-cols-12"
      style={{
        backgroundImage: `url(${bg_onboarding})`,
        flexBasis: 0,
        flexGrow: 3,
      }}
    >
      {/* 1st right half */}
      <div className="col-span-6">
        {/* <img className="w-full h-screen" src={LeftSide_Step4} alt="step4 image" /> */}
      </div>

      {/* 2nd left half */}
      <div className="col-span-6 flex items-center justify-center w-full ">
        <div className="w-full mx-10">
          <div className="border-2 rounded-lg w-full bg-white">
            <div className=" mb-4">
              <div className="mx-5 mt-5 gap-6 ">
                <p className="font-raleway font-normal text-xs h-4 mt-6">
                  Step 4/4
                </p>
                <h1 className="font-raleway font-bold text-3xl h-4 mt-4 leading-6">
                  Preview Settings
                </h1>

                <div className=" mt-8">
                  <h1
                    className="font-raleway"
                    style={{
                      color: "#8C8C8C",
                      fontSize: "12px",
                      fontWeight: 600,
                      lineHeight: "22px",
                    }}
                  >
                    Deposit Account Type:
                  </h1>
                  <div className="flex gap-4  justify-start">
                    <CheckOutlined
                      style={{
                        color: tickIconColor,
                        width: "10px",
                        height: "8px",
                      }}
                    />
                    <h2
                      className="font-raleway"
                      style={{
                        color: "#242424",
                        fontSize: "12px",
                        fontWeight: 400,
                        lineHeight: "11px",
                      }}
                    >
                      {formData.deposit_account}
                    </h2>
                  </div>
                </div>
              </div>

              <Divider style={{ marginTop: 4, marginBottom: 4 }} />

              <div className="mx-5 mt-3 ">
                <div className="  ">
                  <h1
                    className="font-raleway"
                    style={{
                      color: "#8C8C8C",
                      fontSize: "12px",
                      fontWeight: 600,
                      lineHeight: "22px",
                    }}
                  >
                    Sync Product Settings:
                  </h1>
                  {formData.createItem == "non_inventory" ? (
                    <div className="mt-4">
                      <div className="flex gap-4  justify-start">
                        <CheckOutlined
                          style={{
                            color: tickIconColor,
                            width: "10px",
                            height: "8px",
                          }}
                        />
                        <h2
                          className="font-raleway"
                          style={{
                            color: "#242424",
                            fontSize: "11px",
                            fontWeight: 600,
                            lineHeight: "11px",
                          }}
                        >
                          Non-Inventoried Items:
                        </h2>
                      </div>

                      <div className="ml-6 mt-1">
                        <div className="flex gap-4  justify-start ">
                          <CheckOutlined
                            style={{
                              color: tickIconColor,
                              width: "10px",
                              height: "8px",
                            }}
                          />
                          <h2
                            className="font-raleway"
                            style={{
                              color: "#242424",
                              fontSize: "12px",
                              fontWeight: 400,
                              lineHeight: "11px",
                            }}
                          >
                            Income Account: {formData.item_income_account}
                          </h2>
                        </div>

                        <div className="flex gap-4  justify-start mt-1">
                          <CheckOutlined
                            style={{
                              color: tickIconColor,
                              width: "10px",
                              height: "8px",
                            }}
                          />
                          <h2
                            className="font-raleway"
                            style={{
                              color: "#242424",
                              fontSize: "12px",
                              fontWeight: 400,
                              lineHeight: "11px",
                            }}
                          >
                            Income Account:{" " + formData.item_expense_account}
                          </h2>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="mt-4 ">
                      <div className="flex gap-4  justify-start">
                        <CheckOutlined
                          style={{
                            color: tickIconColor,
                            width: "10px",
                            height: "8px",
                          }}
                        />
                        <h2
                          className="font-raleway"
                          style={{
                            color: "#242424",
                            fontSize: "11px",
                            fontWeight: 600,
                            lineHeight: "11px",
                          }}
                        >
                          Inventoried Items:
                        </h2>
                      </div>

                      <div className="ml-6 mt-1">
                        <div className="flex gap-4  justify-start ">
                          <CheckOutlined
                            style={{
                              color: tickIconColor,
                              width: "10px",
                              height: "8px",
                            }}
                          />
                          <h2
                            className="font-raleway"
                            style={{
                              color: "#242424",
                              fontSize: "12px",
                              fontWeight: 400,
                              lineHeight: "11px",
                            }}
                          >
                            Income Account:
                            {" " + formData.item_income_inventory}
                          </h2>
                        </div>

                        <div className="flex gap-4  justify-start mt-1">
                          <CheckOutlined
                            style={{
                              color: tickIconColor,
                              width: "10px",
                              height: "8px",
                            }}
                          />
                          <h2
                            className="font-raleway"
                            style={{
                              color: "#242424",
                              fontSize: "12px",
                              fontWeight: 400,
                              lineHeight: "11px",
                            }}
                          >
                            COGS Account:{" " + formData.item_cogs_inventory}
                          </h2>
                        </div>

                        <div className="flex gap-4  justify-start mt-1">
                          <CheckOutlined
                            style={{
                              color: tickIconColor,
                              width: "10px",
                              height: "8px",
                            }}
                          />
                          <h2
                            className="font-raleway"
                            style={{
                              color: "#242424",
                              fontSize: "12px",
                              fontWeight: 400,
                              lineHeight: "11px",
                            }}
                          >
                            Asset Account:{" " + formData.item_asset_inventory}
                          </h2>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <Divider style={{ marginTop: 4, marginBottom: 4 }} />

              <div className="mx-5 mt-3 ">
                <div className="  ">
                  <h1
                    className="font-raleway"
                    style={{
                      color: "#8C8C8C",
                      fontSize: "12px",
                      fontWeight: 600,
                      lineHeight: "22px",
                    }}
                  >
                    Sync Type:
                  </h1>

                  {/* Both */}
                  {formData.syncType == "both" && (
                    <div className="mt-4">
                      <div className="flex gap-4  justify-start">
                        <CheckOutlined
                          style={{
                            color: tickIconColor,
                            width: "10px",
                            height: "8px",
                          }}
                        />
                        <h2
                          className="font-raleway"
                          style={{
                            color: "#242424",
                            fontSize: "11px",
                            fontWeight: 600,
                            lineHeight: "11px",
                          }}
                        >
                          Both manual and live sync:
                        </h2>
                      </div>

                      <div className="ml-6 mt-1">
                        <div className="flex gap-4  justify-start ">
                          <CheckOutlined
                            style={{
                              color: tickIconColor,
                              width: "10px",
                              height: "8px",
                            }}
                          />
                          <h2
                            className="font-raleway"
                            style={{
                              color: "#242424",
                              fontSize: "12px",
                              fontWeight: 400,
                              lineHeight: "11px",
                            }}
                          >
                            Your integrations from Shopify to QBO will start on:{" "}
                            {moment(formData.inventoryStartDate).format(
                              "MMMM, Do YYYY"
                            )}
                          </h2>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Manual Sync */}
                  {formData.syncType == "manualSync" && (
                    <div className="mt-4">
                      <div className="flex gap-4  justify-start">
                        <CheckOutlined
                          style={{
                            color: tickIconColor,
                            width: "10px",
                            height: "8px",
                          }}
                        />
                        <h2
                          className="font-raleway"
                          style={{
                            color: "#242424",
                            fontSize: "11px",
                            fontWeight: 600,
                            lineHeight: "11px",
                          }}
                        >
                          Manual Sync:
                        </h2>
                      </div>

                      <div className="ml-6 mt-1">
                        <div className="flex gap-4  justify-start ">
                          <CheckOutlined
                            style={{
                              color: tickIconColor,
                              width: "10px",
                              height: "8px",
                            }}
                          />
                          <h2
                            className="font-raleway"
                            style={{
                              color: "#242424",
                              fontSize: "12px",
                              fontWeight: 400,
                              lineHeight: "11px",
                            }}
                          >
                            Your integrations from Shopify to QBO will start on:{" "}
                            {moment(formData.inventoryStartDate).format(
                              "MMMM, Do YYYY"
                            )}
                          </h2>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Live  */}
                  {formData.syncType == "liveSync" && (
                    <div className="mt-4">
                      <div className="flex gap-4  justify-start">
                        <CheckOutlined
                          style={{
                            color: tickIconColor,
                            width: "10px",
                            height: "8px",
                          }}
                        />
                        <h2
                          className="font-raleway"
                          style={{
                            color: "#242424",
                            fontSize: "11px",
                            fontWeight: 600,
                            lineHeight: "11px",
                          }}
                        >
                          Live Sync:
                        </h2>
                      </div>

                      <div className="ml-6 mt-1">
                        <div className="flex gap-4  justify-start ">
                          <CheckOutlined
                            style={{
                              color: tickIconColor,
                              width: "10px",
                              height: "8px",
                            }}
                          />
                          <h2
                            className="font-raleway"
                            style={{
                              color: "#242424",
                              fontSize: "12px",
                              fontWeight: 400,
                              lineHeight: "11px",
                            }}
                          >
                            New changes will be synced automatically
                          </h2>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <Divider style={{ marginTop: 4, marginBottom: 4 }} />
            </div>

            <Form
              form={form}
              name="sync_settings"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
            >
              <div className="px-5">
                <Form.Item
                  name="termsAndConditions"
                  valuePropName="checked"
                  rules={[
                    {
                      required: true,
                      message: "Please check terms and conditions!",
                    },
                  ]}
                >
                  <Checkbox
                  // defaultChecked={true}
                  // checked={true}
                  // disabled={disabled}
                  // onChange={onChange}
                  className="font-raleway"
                  >
                    <h2 className="font-raleway">I agree to <NavLink to='/userAgreement' target='_blank' rel="noopener noreferrer">terms & conditions</NavLink></h2>
                    <Typography.Paragraph
                      style={{
                        lineHeight: "17px",
                        paddingBottom: -10,
                        fontSize: "10px",
                      }}
                    >
                      By using this form you agree with storage and handling of you data in accordance with our{" "}
                        <NavLink to='/privacyPolicy' target='_blank' rel="noopener noreferrer"> Privacy Policy </NavLink>
                    </Typography.Paragraph>
                  </Checkbox>
                </Form.Item>
              </div>

              {/* Footer Buttons */}
              <div className="flex gap-6 justify-end mt-8 mb-9 mr-5">
                <Button
                  loading={false}
                  className="  w-24"
                  onClick={moveBackStep}
                >
                  Back
                </Button>

                <Button
                  loading={isShowLoading}
                  className="  w-24"
                  type="primary"
                  htmlType="submit"
                  // onClick={SaveSettings}
                >
                  Save
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Step4;
